import React, { useState, useEffect } from 'react';
import { AppView, RegionInfo, SavedCalculation, ToolItem } from './types';
import { REGIONS } from './data/regionsData';
import { TOOLS_DIRECTORY } from './data/toolsData';
import { GlobalHeader } from './components/navigation/GlobalHeader';
import { GlobalFooter } from './components/navigation/GlobalFooter';
import { MobileNavDrawer } from './components/navigation/MobileNavDrawer';
import { MobileBottomBar } from './components/navigation/MobileBottomBar';
import { SmartSearchModal } from './components/search/SmartSearchModal';
import { ToolDiscoveryWizard } from './components/discovery/ToolDiscoveryWizard';
import { UserWorkspaceModal } from './components/workspace/UserWorkspaceModal';
import { HomepageView } from './components/views/HomepageView';
import { AllToolsView } from './components/views/AllToolsView';
import { ActiveToolView } from './components/views/ActiveToolView';
import { ArchitectureView } from './components/views/ArchitectureView';
import { DataGovernanceView } from './components/governance/DataGovernanceView';
import { CurrencyIntelligenceHub } from './components/fx/CurrencyIntelligenceHub';
import { MoneyTransferHub } from './components/transfer/MoneyTransferHub';
import { SalaryIntelligenceHub } from './components/salary/SalaryIntelligenceHub';
import { LoanIntelligenceHub } from './components/loan/LoanIntelligenceHub';
import { MyYamooPayHub } from './components/identity/MyYamooPayHub';
import { AuthModal } from './components/identity/AuthModal';
import { FinancialGuidesHub } from './components/seo/FinancialGuidesHub';
import { EditorialCmsHub } from './components/seo/EditorialCmsHub';
import { OrganicGrowthCenter } from './components/seo/OrganicGrowthCenter';
import { GlossaryHub } from './components/seo/GlossaryHub';
import { MethodologyHub } from './components/seo/MethodologyHub';
import { MonetizationCommandCenter } from './components/monetization/MonetizationCommandCenter';
import { AdInventoryManager } from './components/monetization/AdInventoryManager';
import { ConsentPrivacyEngine } from './components/monetization/ConsentPrivacyEngine';
import { AffiliateCommandCenter } from './components/monetization/AffiliateCommandCenter';
import { CommercialGovernanceHub } from './components/monetization/CommercialGovernanceHub';
import { ExecutiveCommandCenter } from './components/analytics/ExecutiveCommandCenter';
import { EventRegistryView } from './components/analytics/EventRegistryView';
import { FunnelsCohortsView } from './components/analytics/FunnelsCohortsView';
import { AttributionExperimentationView } from './components/analytics/AttributionExperimentationView';
import { AnalyticsPrivacyQualityHub } from './components/analytics/AnalyticsPrivacyQualityHub';
import { GrowthCommandCenter } from './components/growth/GrowthCommandCenter';
import { WealthCommandCenter } from './components/wealth/WealthCommandCenter';
import { EverydayCommandCenter } from './components/everyday/EverydayCommandCenter';
import { PercentageDiscountCalculator } from './components/everyday/PercentageDiscountCalculator';
import { TaxTipSplitCalculator } from './components/everyday/TaxTipSplitCalculator';
import { WorkHoursOvertimeCalculator } from './components/everyday/WorkHoursOvertimeCalculator';
import { FuelElectricityCalculator } from './components/everyday/FuelElectricityCalculator';
import { UnitConverterCalculator } from './components/everyday/UnitConverterCalculator';
import { DateAgeCalculator } from './components/everyday/DateAgeCalculator';
import { HealthWellnessCalculator } from './components/everyday/HealthWellnessCalculator';
import { AiCommandCenter } from './components/ai/AiCommandCenter';
import { AiSearchAssistantModal } from './components/ai/AiSearchAssistantModal';
import { AdminSuperCommandCenter } from './components/admin/AdminSuperCommandCenter';
import { SystemOverview } from './components/admin/SystemOverview';
import { SystemHealthDeployments } from './components/admin/SystemHealthDeployments';
import { OrganizationsManagement } from './components/admin/OrganizationsManagement';
import { RolesPermissionsManagement } from './components/admin/RolesPermissionsManagement';
import { AiPlatformManagement } from './components/admin/AiPlatformManagement';
import { ComplianceMonitor } from './components/admin/ComplianceMonitor';
import { AuditLogsManagement } from './components/admin/AuditLogsManagement';
import { AuditReportsManagement } from './components/admin/AuditReportsManagement';
import { SystemConfigurationManagement } from './components/admin/SystemConfigurationManagement';
import { MonetizationControlCenter } from './components/finance/MonetizationControlCenter';
import { ProductionCommandCenter } from './components/devops/ProductionCommandCenter';
import { CisoCommandCenter } from './components/security/CisoCommandCenter';
import { MobileExperienceCommandCenter } from './components/mobile/MobileExperienceCommandCenter';
import { DeveloperPortal } from './components/developer/DeveloperPortal';
import { DeveloperCommandCenter } from './components/developer/DeveloperCommandCenter';
import { BillingCommandCenter } from './components/billing/BillingCommandCenter';
import { CustomerBillingPortal } from './components/billing/CustomerBillingPortal';
import { ChiefComplianceOfficerCommandCenter } from './components/compliance/ChiefComplianceOfficerCommandCenter';
import { LegalAndCompliancePortal } from './components/compliance/LegalAndCompliancePortal';
import { ChiefQualityOfficerCommandCenter } from './components/quality/ChiefQualityOfficerCommandCenter';
import { GlobalExpansionCommandCenter } from './components/globalization/GlobalExpansionCommandCenter';
import { GlobalHelpCenterPortal } from './components/support/GlobalHelpCenterPortal';
import { ChiefCustomerExperienceOfficerCommandCenter } from './components/support/ChiefCustomerExperienceOfficerCommandCenter';
import { EngineeringPortal } from './components/platform/EngineeringPortal';
import { ChiefTechnologyOfficerCommandCenter } from './components/platform/ChiefTechnologyOfficerCommandCenter';
import { ChiefDataOfficerCommandCenter } from './components/data/ChiefDataOfficerCommandCenter';
import { EnterpriseDataCatalogPortal } from './components/data/EnterpriseDataCatalogPortal';
import { ChiefAIOfficerCommandCenter } from './components/ai/ChiefAIOfficerCommandCenter';
import { AISandboxPlayground } from './components/ai/AISandboxPlayground';
import { ChiefProductOfficerCommandCenter } from './components/product/ChiefProductOfficerCommandCenter';
import { ChiefFinancialOfficerCommandCenter } from './components/finance/ChiefFinancialOfficerCommandCenter';
import { ChiefRevenueOfficerCommandCenter } from './components/sales/ChiefRevenueOfficerCommandCenter';
import { ChiefRiskOfficerCommandCenter } from './components/risk/ChiefRiskOfficerCommandCenter';
import { SystemQACoherenceAudit } from './components/quality/SystemQACoherenceAudit';
import { SecurityProductionGateAudit } from './components/security/SecurityProductionGateAudit';
import { AccessDenied403 } from './components/auth/AccessDenied403';
import { UserProfileView } from './components/auth/UserProfileView';
import { UserAuthModal } from './components/auth/UserAuthModal';
import { DataSourceManagementView } from './components/data/DataSourceManagementView';
import { authEngine } from './services/auth/authEngine';
import { authService } from './services/auth/authService';
import { networkEngine } from './services/mobile/networkStateEngine';
import { NetworkState } from './services/mobile/offlineDataTypes';
import { WifiOff } from 'lucide-react';

export default function App() {
  const [currentView, setCurrentView] = useState<AppView>('homepage');
  const [lastNonAdminView, setLastNonAdminView] = useState<AppView>('homepage');
  const [activeToolId, setActiveToolId] = useState<string>('currency-converter');
  const [selectedRegion, setSelectedRegion] = useState<RegionInfo>(REGIONS[0]); // Default US
  const [networkState, setNetworkState] = useState<NetworkState>(networkEngine.getNetworkState());
  
  // Track last non-admin tool/page for smart redirection upon session closure / logout
  useEffect(() => {
    const isAdminView =
      currentView.startsWith('admin-') ||
      currentView === 'cfo-command-center' ||
      currentView === 'cro-revenue-command-center' ||
      currentView === 'ciso-command-center' ||
      currentView === 'cto-command-center' ||
      currentView === 'cdo-command-center' ||
      currentView === 'caio-command-center' ||
      currentView === 'security-production-gate' ||
      currentView === 'qa-coherence-audit';

    if (!isAdminView && currentView !== 'access-denied-403') {
      setLastNonAdminView(currentView);
    }
  }, [currentView]);

  // Reactive listener for session closure & logout events
  useEffect(() => {
    const unsubAuth = authEngine.subscribe(() => {
      const currentUser = authEngine.getCurrentUser();
      if (!currentUser || currentUser.isGuest) {
        const isAdminView =
          currentView.startsWith('admin-') ||
          currentView === 'cfo-command-center' ||
          currentView === 'cro-revenue-command-center' ||
          currentView === 'cro-risk-command-center' ||
          currentView === 'ciso-command-center' ||
          currentView === 'cto-command-center' ||
          currentView === 'cdo-command-center' ||
          currentView === 'caio-command-center' ||
          currentView === 'security-production-gate' ||
          currentView === 'qa-coherence-audit';

        if (isAdminView) {
          setCurrentView(lastNonAdminView || 'homepage');
        }
      }
    });
    return () => unsubAuth();
  }, [currentView, lastNonAdminView]);
  
  // Service Worker Registration & Network Engine Sync
  useEffect(() => {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          console.log('[YamooPay PWA] Service Worker registered with scope:', reg.scope);
        })
        .catch((err) => {
          console.warn('[YamooPay PWA] Service Worker registration failed:', err);
        });
    }

    const unsubNet = networkEngine.subscribe((state) => {
      setNetworkState(state);
    });
    return () => unsubNet();
  }, []);
  
  // Modals & Drawers & Auth State
  const [searchOpen, setSearchOpen] = useState(false);
  const [workspaceOpen, setWorkspaceOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [userAuthModalOpen, setUserAuthModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(() => authService.getSession().isLoggedIn);

  // Local Storage for Saved Calculations
  const [savedCalculations, setSavedCalculations] = useState<SavedCalculation[]>(() => {
    try {
      const stored = localStorage.getItem('yamoopay_saved_calculations');
      return stored ? JSON.parse(stored) : [
        {
          id: '1',
          toolId: 'salary-calculator',
          toolName: 'Salary & Paycheck Calculator',
          timestamp: Date.now() - 3600000 * 2,
          primaryResult: '$4,862 / month',
          subtitle: 'Gross $75,000 in United States',
          inputsSummary: 'Single filer • Standard Deduction • 2026 IRS',
          region: 'US',
        },
        {
          id: '2',
          toolId: 'currency-converter',
          toolName: 'Currency Converter',
          timestamp: Date.now() - 3600000 * 24,
          primaryResult: '923.40 EUR',
          subtitle: '1,000 USD → EUR',
          inputsSummary: 'Mid-Market: 1 USD = 0.9234 EUR',
          region: 'Global',
        },
      ];
    } catch {
      return [];
    }
  });

  const [favoriteCurrencies, setFavoriteCurrencies] = useState<string[]>(() => {
    try {
      const stored = localStorage.getItem('yamoopay_fav_currencies');
      return stored ? JSON.parse(stored) : ['USD', 'EUR', 'GBP', 'CAD', 'JPY'];
    } catch {
      return ['USD', 'EUR', 'GBP', 'CAD', 'JPY'];
    }
  });

  // Save to localStorage on change
  useEffect(() => {
    try {
      localStorage.setItem('yamoopay_saved_calculations', JSON.stringify(savedCalculations));
    } catch (e) {
      console.error(e);
    }
  }, [savedCalculations]);

  useEffect(() => {
    try {
      localStorage.setItem('yamoopay_fav_currencies', JSON.stringify(favoriteCurrencies));
    } catch (e) {
      console.error(e);
    }
  }, [favoriteCurrencies]);

  useEffect(() => {
    const handleCustomNav = () => {
      setCurrentView('governance');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    window.addEventListener('navigate-governance', handleCustomNav);
    return () => window.removeEventListener('navigate-governance', handleCustomNav);
  }, []);

  // Global Keyboard Shortcut (⌘K / Ctrl+K)
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setSearchOpen((prev) => !prev);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleSelectTool = (toolId: string) => {
    if (toolId === 'compare-transfers') {
      setCurrentView('money-transfers');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    setActiveToolId(toolId);
    setCurrentView('active-tool');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigate = (view: AppView) => {
    if (view === 'my-yamoopay' && !isLoggedIn) {
      setUserAuthModalOpen(true);
      return;
    }
    setCurrentView(view);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSaveCalculation = (toolId: string, primaryResult: string, summary: string) => {
    const tool = TOOLS_DIRECTORY.find((t) => t.id === toolId);
    const newCalc: SavedCalculation = {
      id: Date.now().toString(),
      toolId,
      toolName: tool ? tool.name : 'Financial Calculation',
      timestamp: Date.now(),
      primaryResult,
      subtitle: summary,
      inputsSummary: `Jurisdiction: ${selectedRegion.name} (${selectedRegion.currency})`,
      region: selectedRegion.code,
    };
    setSavedCalculations((prev) => [newCalc, ...prev]);
  };

  const handleDeleteSaved = (id: string) => {
    setSavedCalculations((prev) => prev.filter((item) => item.id !== id));
  };

  const handleClearAllSaved = () => {
    setSavedCalculations([]);
  };

  const handleToggleFavoriteCurrency = (curr: string) => {
    setFavoriteCurrencies((prev) =>
      prev.includes(curr) ? prev.filter((c) => c !== curr) : [...prev, curr]
    );
  };

  const activeToolObj = TOOLS_DIRECTORY.find((t) => t.id === activeToolId) || TOOLS_DIRECTORY[0];

  return (
    <div className="min-h-screen bg-[#FBFBFC] text-[#1A1A1A] flex flex-col font-sans selection:bg-[#1A1A1A] selection:text-white">
      {/* 1. Universal Top Header */}
      <GlobalHeader
        currentView={currentView}
        onNavigate={handleNavigate}
        onSelectTool={handleSelectTool}
        selectedRegion={selectedRegion}
        onSelectRegion={setSelectedRegion}
        allRegions={REGIONS}
        tools={TOOLS_DIRECTORY}
        savedCount={savedCalculations.length}
        onOpenSearch={() => setSearchOpen(true)}
        onOpenWorkspace={() => {
          if (isLoggedIn) {
            handleNavigate('my-yamoopay');
          } else {
            setUserAuthModalOpen(true);
          }
        }}
        onOpenAuthModal={() => setUserAuthModalOpen(true)}
        onOpenMobileMenu={() => setMobileMenuOpen(true)}
        isLoggedIn={isLoggedIn}
      />

      {/* 2. Main Dynamic View Container */}
      <main className="flex-1 w-full pb-20 md:pb-0">
        {/* Global Offline Mode Status Banner */}
        {networkState !== 'ONLINE' && (
          <div className="bg-amber-600 text-white px-4 py-2.5 text-xs font-bold text-center flex items-center justify-center gap-2 shadow-xs sticky top-16 z-30">
            <WifiOff className="w-4 h-4" />
            <span>Mode Hors-Ligne Actif — 20+ calculateurs déterministes fonctionnent avec les données de référence en cache.</span>
          </div>
        )}

        {currentView === 'homepage' && (
          <HomepageView
            onNavigate={handleNavigate}
            onSelectTool={handleSelectTool}
            onOpenSearch={() => setSearchOpen(true)}
            selectedRegion={selectedRegion}
            onSelectRegion={setSelectedRegion}
            allRegions={REGIONS}
            tools={TOOLS_DIRECTORY}
            onSaveCalculation={handleSaveCalculation}
          />
        )}

        {currentView === 'tools' && (
          <AllToolsView
            onSelectTool={handleSelectTool}
            onNavigate={handleNavigate}
            tools={TOOLS_DIRECTORY}
            allRegions={REGIONS}
            selectedRegion={selectedRegion}
            onOpenAuthModal={() => setAuthModalOpen(true)}
          />
        )}

        {currentView === 'discovery' && (
          <ToolDiscoveryWizard
            onSelectTool={handleSelectTool}
            tools={TOOLS_DIRECTORY}
            allRegions={REGIONS}
            selectedRegion={selectedRegion}
          />
        )}

        {currentView === 'active-tool' && (
          <ActiveToolView
            tool={activeToolObj}
            onNavigate={handleNavigate}
            onSelectTool={handleSelectTool}
            selectedRegion={selectedRegion}
            onSelectRegion={setSelectedRegion}
            allRegions={REGIONS}
            allTools={TOOLS_DIRECTORY}
            onSaveCalculation={handleSaveCalculation}
          />
        )}

        {currentView === 'architecture' && (
          <ArchitectureView />
        )}

        {currentView === 'governance' && (
          <DataGovernanceView 
            onNavigateHome={() => handleNavigate('homepage')}
            onNavigateTools={() => handleNavigate('tools')}
            onNavigateArchitecture={() => handleNavigate('architecture')}
          />
        )}

        {currentView === 'currency-intelligence' && (
          <CurrencyIntelligenceHub
            onNavigateHome={() => handleNavigate('homepage')}
            onNavigateGovernance={() => handleNavigate('governance')}
            onNavigateArchitecture={() => handleNavigate('architecture')}
          />
        )}

        {currentView === 'money-transfers' && (
          <MoneyTransferHub
            onNavigateHome={() => handleNavigate('homepage')}
            onNavigateFx={() => handleNavigate('currency-intelligence')}
            onNavigateGovernance={() => handleNavigate('governance')}
          />
        )}

        {currentView === 'salary-engine' && (
          <SalaryIntelligenceHub
            onNavigateHome={() => handleNavigate('homepage')}
            onNavigateFx={() => handleNavigate('currency-intelligence')}
            onNavigateTransfers={() => handleNavigate('money-transfers')}
            onNavigateGovernance={() => handleNavigate('governance')}
          />
        )}

        {currentView === 'loan-engine' && (
          <LoanIntelligenceHub />
        )}

        {currentView === 'my-yamoopay' && (
          <MyYamooPayHub
            onNavigateView={handleNavigate}
            onSelectTool={handleSelectTool}
            onOpenAuthModal={() => setAuthModalOpen(true)}
          />
        )}

        {currentView === 'financial-guides' && (
          <FinancialGuidesHub onNavigateToTool={handleNavigate} />
        )}

        {currentView === 'editorial-cms' && (
          <EditorialCmsHub />
        )}

        {currentView === 'organic-growth' && (
          <OrganicGrowthCenter />
        )}

        {currentView === 'glossary' && (
          <GlossaryHub onNavigateToTool={handleNavigate} />
        )}

        {currentView === 'methodology' && (
          <MethodologyHub />
        )}

        {currentView === 'monetization-command-center' && (
          <MonetizationCommandCenter onNavigateToView={handleNavigate} />
        )}

        {currentView === 'ad-inventory-manager' && (
          <AdInventoryManager />
        )}

        {currentView === 'consent-privacy-center' && (
          <ConsentPrivacyEngine />
        )}

        {currentView === 'affiliate-command-center' && (
          <AffiliateCommandCenter onNavigateToTool={handleNavigate} />
        )}

        {currentView === 'commercial-governance' && (
          <CommercialGovernanceHub />
        )}

        {currentView === 'executive-command-center' && (
          <ExecutiveCommandCenter onNavigateToView={handleNavigate} />
        )}

        {currentView === 'product-analytics' && (
          <ExecutiveCommandCenter onNavigateToView={handleNavigate} />
        )}

        {currentView === 'event-registry' && (
          <EventRegistryView />
        )}

        {currentView === 'funnel-cohort-intelligence' && (
          <FunnelsCohortsView />
        )}

        {currentView === 'attribution-experimentation' && (
          <AttributionExperimentationView />
        )}

        {currentView === 'analytics-privacy-quality' && (
          <AnalyticsPrivacyQualityHub />
        )}

        {(currentView === 'growth-command-center' ||
          currentView === 'crm-user-lifecycle' ||
          currentView === 'segment-builder' ||
          currentView === 'campaign-orchestrator' ||
          currentView === 'email-deliverability-hub' ||
          currentView === 'referral-program-hub' ||
          currentView === 'customer-success-center') && (
          <GrowthCommandCenter onNavigateToView={handleNavigate} />
        )}

        {(currentView === 'wealth-command-center' ||
          currentView === 'savings-compound-interest' ||
          currentView === 'future-present-value' ||
          currentView === 'real-return-purchasing-power' ||
          currentView === 'goal-planner-solver' ||
          currentView === 'fire-retirement-projection' ||
          currentView === 'fee-impact-dca' ||
          currentView === 'wealth-scenario-comparison') && (
          <WealthCommandCenter onNavigateToView={handleNavigate} />
        )}

        {currentView === 'everyday-command-center' && (
          <EverydayCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'percentage-calc' && (
          <PercentageDiscountCalculator onNavigateToView={handleNavigate} defaultTab="percentage" />
        )}
        {currentView === 'discount-calc' && (
          <PercentageDiscountCalculator onNavigateToView={handleNavigate} defaultTab="discount" />
        )}
        {currentView === 'margin-calc' && (
          <PercentageDiscountCalculator onNavigateToView={handleNavigate} defaultTab="margin" />
        )}
        {currentView === 'vat-calc' && (
          <TaxTipSplitCalculator onNavigateToView={handleNavigate} defaultTab="vat" />
        )}
        {currentView === 'tip-split-calc' && (
          <TaxTipSplitCalculator onNavigateToView={handleNavigate} defaultTab="tip" />
        )}
        {currentView === 'work-hours-calc' && (
          <WorkHoursOvertimeCalculator onNavigateToView={handleNavigate} />
        )}
        {currentView === 'fuel-electricity-calc' && (
          <FuelElectricityCalculator onNavigateToView={handleNavigate} />
        )}
        {currentView === 'unit-converter-calc' && (
          <UnitConverterCalculator onNavigateToView={handleNavigate} />
        )}
        {currentView === 'date-age-calc' && (
          <DateAgeCalculator onNavigateToView={handleNavigate} />
        )}
        {currentView === 'health-wellness-calc' && (
          <HealthWellnessCalculator onNavigateToView={handleNavigate} />
        )}
        {currentView === 'ai-command-center' && (
          <AiCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'ai-search-assistant' && (
          <AiSearchAssistantModal onNavigateToView={handleNavigate} />
        )}
        {currentView === 'admin-super-command-center' && (
          <AdminSuperCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'admin-system-health' && (
          <SystemHealthDeployments onNavigateToView={handleNavigate} />
        )}
        {currentView === 'admin-organizations' && (
          <OrganizationsManagement onNavigateToView={handleNavigate} />
        )}
        {currentView === 'admin-roles-permissions' && (
          <RolesPermissionsManagement onNavigateToView={handleNavigate} />
        )}
        {(currentView === 'admin-ai-platform' || currentView === 'ai-platform') && (
          <AiPlatformManagement onNavigateToView={handleNavigate} />
        )}
        {(currentView === 'admin-compliance' || currentView === 'compliance-monitor') && (
          <ComplianceMonitor onNavigateToView={handleNavigate} />
        )}
        {(currentView === 'admin-audit' || currentView === 'audit-logs') && (
          <AuditLogsManagement onNavigateToView={handleNavigate} />
        )}
        {(currentView === 'admin-reports' || currentView === 'audit-reports') && (
          <AuditReportsManagement onNavigateToView={handleNavigate} />
        )}
        {(currentView === 'admin-configuration' || currentView === 'configuration') && (
          <SystemConfigurationManagement onNavigateToView={handleNavigate} />
        )}
        {(currentView === 'admin-monetization' || currentView === 'monetization' || currentView === 'revenue-monetization') && (
          <MonetizationControlCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'production-command-center' && (
          <ProductionCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'ciso-security-command-center' && (
          <CisoCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'mobile-command-center' && (
          <MobileExperienceCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'developer-portal' && (
          <DeveloperPortal onNavigateToView={handleNavigate} />
        )}
        {currentView === 'developer-command-center' && (
          <DeveloperCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'billing-command-center' && (
          <BillingCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'customer-billing-portal' && (
          <CustomerBillingPortal onNavigateToView={handleNavigate} />
        )}
        {currentView === 'compliance-command-center' && (
          <ChiefComplianceOfficerCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'legal-portal' && (
          <LegalAndCompliancePortal onNavigateToView={handleNavigate} />
        )}
        {currentView === 'cqo-command-center' && (
          <ChiefQualityOfficerCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'global-expansion-command-center' && (
          <GlobalExpansionCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'help-center' && (
          <GlobalHelpCenterPortal onNavigateToView={handleNavigate} />
        )}
        {currentView === 'cxo-command-center' && (
          <ChiefCustomerExperienceOfficerCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'cto-command-center' && (
          <ChiefTechnologyOfficerCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'internal-developer-platform' && (
          <EngineeringPortal onNavigateToView={handleNavigate} />
        )}
        {currentView === 'cdo-command-center' && (
          <ChiefDataOfficerCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'enterprise-data-catalog' && (
          <EnterpriseDataCatalogPortal onNavigateToView={handleNavigate} />
        )}
        {currentView === 'caio-command-center' && (
          <ChiefAIOfficerCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'ai-sandbox-playground' && (
          <AISandboxPlayground onNavigateToView={handleNavigate} />
        )}
        {(currentView === 'cpo-command-center' || currentView === 'product-bet-matrix') && (
          <ChiefProductOfficerCommandCenter onNavigateToView={handleNavigate} />
        )}
        {(currentView === 'cfo-command-center' || currentView === 'corporate-finance-studio') && (
          <ChiefFinancialOfficerCommandCenter onNavigateToView={handleNavigate} />
        )}
        {(currentView === 'cro-revenue-command-center' ||
          currentView === 'sales-crm-pipeline' ||
          currentView === 'sales-deal-desk' ||
          currentView === 'sales-quotes' ||
          currentView === 'sales-forecast' ||
          currentView === 'partner-ecosystem' ||
          currentView === 'customer-expansion-hub') && (
          <ChiefRevenueOfficerCommandCenter onNavigateToView={handleNavigate} />
        )}
        {(currentView === 'cro-risk-command-center' ||
          currentView === 'enterprise-risk-register' ||
          currentView === 'risk-appetite-kris' ||
          currentView === 'control-testing-lab' ||
          currentView === 'operational-resilience-bcp' ||
          currentView === 'fraud-risk-governance' ||
          currentView === 'insurance-risk-transfer' ||
          currentView === 'assurance-internal-audit') && (
          <ChiefRiskOfficerCommandCenter onNavigateToView={handleNavigate} />
        )}
        {currentView === 'qa-coherence-audit' && (
          <SystemQACoherenceAudit onNavigateToView={handleNavigate} />
        )}
        {currentView === 'security-production-gate' && (
          <SecurityProductionGateAudit onNavigateToView={handleNavigate} />
        )}
        {currentView === 'user-auth-profile' && (
          <UserProfileView
            onNavigateToView={handleNavigate}
            onLogout={() => {
              authService.logout();
              setIsLoggedIn(false);
              setCurrentView('homepage');
            }}
          />
        )}
        {currentView === 'data-source-management' && (
          <DataSourceManagementView onNavigateToView={handleNavigate} />
        )}
      </main>

      {/* 3. Global Footer */}
      <GlobalFooter
        onNavigate={handleNavigate}
        onSelectTool={handleSelectTool}
        selectedRegion={selectedRegion}
        onSelectRegion={setSelectedRegion}
        allRegions={REGIONS}
        tools={TOOLS_DIRECTORY}
      />

      {/* 4. Mobile Bottom Bar */}
      <MobileBottomBar
        currentView={currentView}
        onNavigate={handleNavigate}
        onOpenSearch={() => setSearchOpen(true)}
        onOpenWorkspace={() => {
          if (isLoggedIn) {
            setWorkspaceOpen(true);
          } else {
            setUserAuthModalOpen(true);
          }
        }}
        onOpenAuthModal={() => setUserAuthModalOpen(true)}
        savedCount={savedCalculations.length}
        isLoggedIn={isLoggedIn}
      />

      {/* 5. Mobile Nav Drawer */}
      <MobileNavDrawer
        isOpen={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        onNavigate={handleNavigate}
        onSelectTool={handleSelectTool}
        selectedRegion={selectedRegion}
        onSelectRegion={setSelectedRegion}
        allRegions={REGIONS}
        tools={TOOLS_DIRECTORY}
        onOpenSearch={() => setSearchOpen(true)}
        onOpenWorkspace={() => {
          if (isLoggedIn) {
            setWorkspaceOpen(true);
          } else {
            setUserAuthModalOpen(true);
          }
        }}
        onOpenAuthModal={() => setUserAuthModalOpen(true)}
        isLoggedIn={isLoggedIn}
      />

      {/* 6. YamooPay Public Global Search / Command Palette (Page 23) */}
      <SmartSearchModal
        isOpen={searchOpen}
        onClose={() => setSearchOpen(false)}
        onSelectTool={handleSelectTool}
        onNavigateView={handleNavigate}
        onSelectRegion={setSelectedRegion}
        selectedRegion={selectedRegion}
        tools={TOOLS_DIRECTORY}
      />

      {/* 7. My YamooPay User Workspace Modal */}
      <UserWorkspaceModal
        isOpen={workspaceOpen}
        onClose={() => setWorkspaceOpen(false)}
        savedCalculations={savedCalculations}
        onDeleteSaved={handleDeleteSaved}
        onClearAllSaved={handleClearAllSaved}
        onReopenCalculation={handleSelectTool}
        favoriteCurrencies={favoriteCurrencies}
        onToggleFavoriteCurrency={handleToggleFavoriteCurrency}
        selectedRegion={selectedRegion}
      />

      {/* 8. User Auth & Registration Modal */}
      <UserAuthModal
        isOpen={userAuthModalOpen}
        onClose={() => setUserAuthModalOpen(false)}
        onSessionUpdated={(session) => {
          setIsLoggedIn(session.isLoggedIn);
        }}
      />
    </div>
  );
}
